import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { LorenErrorTemplateComponent } from "../loren-error-template/loren-error-template.component";

@Component({
    selector: "loren-general-error",
    imports: [TranslocoPipe, LorenErrorTemplateComponent],
    templateUrl: "./loren-general-error.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./loren-general-error.component.scss"]
})
export class LorenGeneralErrorComponent {}
